import { Box, styled } from '@mui/material';

export const StatusWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0.5, 2),
  borderRadius: theme.spacing(0.5),
  textAlign: 'center',
  backgroundColor: theme.palette.success.main,
  color: theme.palette.success.dark
}));
